import { consumptionAPI } from "./clients";
import { CancelToken } from "axios";
const END_POINT = "/analysis";
const analysisPipeline = CancelToken.source();

const getAnalysisWidgets = widgetList => {
  return consumptionAPI.post(END_POINT, widgetList, {
    cancelToken: analysisPipeline.token,
  });
};

export { getAnalysisWidgets, analysisPipeline };
